import { v4 as uuidv4 } from 'uuid';
function shouldSetClientInfo(config) {
    if (!('platform' in config) || typeof config.platform !== 'string') {
        return false;
    }
    if (!('appConfig' in config) ||
        typeof config.appConfig !== 'object' ||
        config.appConfig === null) {
        return false;
    }
    const { appConfig } = config;
    return 'name' in appConfig && 'project' in appConfig && 'version' in appConfig;
}
function getClientInfo({ platform, appConfig: { name, project, version }, }) {
    return `${platform}-${name}/${version} project:${project}`;
}
export function getDefaultRequestHeaders(config) {
    const { appConfig: { version, type, developmentState } = {}, platform, requestTTL } = config;
    return {
        ...{ 'Glovo-Request-Id': uuidv4() },
        ...(platform ? { 'Glovo-App-Platform': platform } : {}),
        ...(type ? { 'Glovo-App-Type': type } : {}),
        ...(version ? { 'Glovo-App-Version': version } : {}),
        ...(developmentState ? { 'Glovo-App-Development-State': developmentState } : {}),
        ...(requestTTL ? { 'Glovo-Request-TTL': requestTTL } : {}),
        ...(shouldSetClientInfo(config) ? { 'Glovo-Client-Info': getClientInfo(config) } : {}),
    };
}
//# sourceMappingURL=get-default-request-headers.js.map